var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.98 8.25v1.5q0 .305-.223.527-.222.223-.527.223h-3.75v3.75q0 .305-.223.527-.222.223-.527.223h-1.5q-.305 0-.527-.223-.223-.222-.223-.527V10.5H3.73q-.305 0-.527-.223-.223-.222-.223-.527v-1.5q0-.305.223-.527.222-.223.527-.223h3.75V3.75q0-.305.223-.527Q7.925 3 8.23 3h1.5q.305 0 .527.223.223.222.223.527V7.5h3.75q.305 0 .527.223.223.222.223.527zm3 6.375V3.375q0-1.395-.99-2.385Q16 0 14.605 0H3.355Q1.961 0 .97.99q-.99.99-.99 2.385v11.25q0 1.395.99 2.385.99.99 2.385.99h11.25q1.395 0 2.385-.99.99-.99.99-2.385z"
  })));
};
export default SvgZoomIn;